import { Box, Stack } from '@mui/material'

const FsContainer = ({
  children,
  footer = null,
}: {
  children: React.ReactNode
  footer?: React.ReactNode
}) =>
  footer ? (
    <Box>
      <Box
        maxHeight="calc(100vh - 321px)"
        maxWidth="1070px"
        sx={{ overflowY: 'scroll', overflowX: 'hidden' }}
      >
        <Box maxWidth="1050px" overflow="hidden">
          {children}
        </Box>
      </Box>
      <Stack direction="row" justifyContent="flex-end" p={0} pt={2} maxWidth="1050px">
        {footer}
      </Stack>
    </Box>
  ) : (
    <Box
      maxHeight="calc(100vh - 263px)"
      sx={{ overflowY: 'scroll', overflowX: 'hidden' }}
      maxWidth="1070px"
    >
      <Box maxWidth="1050px" overflow="hidden">
        {children}
      </Box>
    </Box>
  )

export default FsContainer
